var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "max-width": "900px",
        height: "600px",
        bus: _vm.busModal,
        persistent: ""
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.sendData(close)
                    }
                  }
                },
                [_vm._v(" Cadastrar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("SectionTitle", { attrs: { title: "Cadastro de profissionais" } }),
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          _c("v-textarea", {
            staticStyle: { "margin-top": "20px" },
            attrs: {
              required: "",
              rules: [_vm.rules.emails],
              label: "Cadastre o email dos seus profissionais",
              placeholder: "email1@email.com;email2@email.com;email3@email.com"
            },
            model: {
              value: _vm.professionals,
              callback: function($$v) {
                _vm.professionals = $$v
              },
              expression: "professionals"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }